import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';

const ItemCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [name, setName] = useState("");
    const [gstRate, setGstRate] = useState("");
    const [isSubmit, setisSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const clearForm = () => {
        setName("");
        setGstRate("0");
    };

    const submitData = async (e) => {
        e.preventDefault();
        
        if (!name) {
            setErrorMessage("All fields are required!");            
            return;
        }

        const CreateData = {
            Name: name,
            GSTRate: gstRate,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('CategoryApi', CreateData, token)
            .then((response) => {
                console.log('Category Created success:', response);
                setSuccessMessage("Category Created successfully!");
                setErrorMessage("");
                clearForm();
                history.push('/ItemIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h5 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',color:'black' }}>ITEM CREATE</h5>
                        
                        <Button
                            // variant="contained"
                            // style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                            style={{
                                backgroundColor:'green',
                                borderRadius: '30px',
                                padding: '10px 20px',
                                color: 'whitesmoke',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '35px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginLeft: '10px',
                               
                            }}
                            onClick={submitData}
                        >
                            SAVE
                        </Button>

                        <Button
                            // variant="contained"
                            // color="error"
                            component={Link}
                            to="/ItemIndex"
                            className="linkcolor"
                            // style={{ marginLeft: '8px' }}
                            style={{
                                backgroundColor:'brown',
                                borderRadius: '30px',
                                padding: '10px 20px',
                                color: 'whitesmoke',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '35px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginLeft: '10px',
                               
                            }}
                        >
                            BACK TO LIST
                        </Button>

                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex">

                        <div className="w-1/2 mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="name" style={{fontSize:'14px'}}>
                                ITEM NAME
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Enter Item Name"
                                required
                                maxLength={50}
                            />
                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base  mb-2" htmlFor="rate" style={{fontSize:'14px'}}>
                                GST RATE
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                value={gstRate}
                                onChange={(e) => setGstRate(e.target.value)}
                                type="number"
                                placeholder="Enter GST Rate"
                                required
                            />
                        </div>
                    </div>

                </form>
            </div>
        </Fragment>
    );
}

export default ItemCreate;

